"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
  "ro": {
    "translation": {
      "formElement": {
        "optional": "(opțional)",
        "required": "(obligatoriu)"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Lună",
        "year": "An"
      },
      "actions": {
        "apply": "Aplică",
        "cancel": "Anulare"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=ro.js.map